import { render, staticRenderFns } from "./shangBao.vue?vue&type=template&id=3d3299b3&scoped=true"
import script from "./shangBao.vue?vue&type=script&lang=js"
export * from "./shangBao.vue?vue&type=script&lang=js"
import style0 from "./shangBao.vue?vue&type=style&index=0&id=3d3299b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3299b3",
  null
  
)

export default component.exports